var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlockOutline = function SvgUnlockOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.424 9.03H2.578c-.862 0-1.563.7-1.563 1.562v10.721c0 .861.7 1.562 1.563 1.562h12.846c.86 0 1.561-.7 1.561-1.562v-10.72c0-.863-.7-1.564-1.561-1.564Zm.561 12.283c0 .31-.252.562-.561.562H2.578a.563.563 0 0 1-.563-.562v-10.72c0-.311.252-.564.563-.564h12.846c.31 0 .561.253.561.563v10.721Zm-5.124-6.623a1.86 1.86 0 0 1-1.152 1.718v1.959a.708.708 0 0 1-1.417 0v-1.959A1.858 1.858 0 0 1 9 12.831a1.86 1.86 0 0 1 1.861 1.859Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.475 7.029h-1v-.43A4.48 4.48 0 0 0 17 2.126 4.48 4.48 0 0 0 12.525 6.6v2.429h-1v-2.43A5.481 5.481 0 0 1 17 1.126 5.481 5.481 0 0 1 22.475 6.6v.429Z"
  })));
};
export default SvgUnlockOutline;